(() => {
  const config = document.getElementById('IflLabMixGiftImage');
  if (!config) return;
  const source = JSON.parse(config.textContent);
  const selector = '[id^="gfgFGv2-6aca82cb4fbf372123848b90-"] .gfgFGv2-gifts-list';
  let queued = false;
  const update = () => {
    queued = false;
    document.querySelectorAll(selector).forEach(list => {
      const image = list.querySelector('.gfgFGv2-gift-row:first-child img.gfgFGv2-img');
      if (!image || image.getAttribute('src') === source) return;
      image.removeAttribute('srcset');
      image.setAttribute('src', source);
      image.setAttribute('alt', 'Research-grade water — 10 mL');
    });
  };
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(update);
  }).observe(document.body, { childList: true, subtree: true });
  update();
})();
